import CheckboxFieldComponent from './checkbox-field-component';

/***
 * A field that renders a row of checkbox options. It expects to be passed a lost of options, with each option being
 * an object containing a "label" parameter.
 */
const checkboxField = angular
    .module('FacilityData.ClientEdit.FormFields.CheckboxField', [])
    .component('checkboxField', CheckboxFieldComponent)
    .name;

export default checkboxField;


// WEBPACK FOOTER //
// ./app/common/form-fields/checkbox-field/checkbox-field.js